import '@fontsource/crete-round/400.css';
import '@fontsource-variable/atkinson-hyperlegible-next/wght.css';
import './styles/tokens.css';
import './styles/base.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router/dom';
import { startAnalytics } from './app/analytics';
import { Providers } from './app/Providers';
import { router } from './app/router';
import { registerServiceWorker } from './app/registerServiceWorker';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);

registerServiceWorker();
startAnalytics();
